// @jsx jsx
import { jsx, useColorMode } from "theme-ui"
import { useEffect, useState, Fragment } from "react"
import LogoMaze from "./logo-maze"

const TIME = 130

const MessageSender = ({ children }) => {
  const [colorMode, setColorMode] = useColorMode()
  const [current, setCurrent] = useState(0)

  const words = children.split(" ")
  words.push(" ")
  const i = Math.floor(current / 2) % words.length
  const word = words[i]
  const isMaze = word === "MAZE"

  useEffect(() => {
    let timer

    timer = setTimeout(() => {
      setColorMode(colorMode === "default" ? "light" : "default")
      setCurrent(current + 1)
    }, TIME)

    return () => clearTimeout(timer)
  })

  return (
    <span
      sx={{
        fontWeight: "bold",
        fontSize: [4, 6],
        textAlign: "center",
      }}
    >
      {isMaze ? <LogoMaze /> : word === "|" ? "" : word}
    </span>
  )
}

export default MessageSender
